import { Fragment, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import { useHistory, useLocation } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    getDatefromWeekNum0, getTimeStamp, 
    boolAndReducer, numberReducer, weeknum, 
    myAxios, MyFormData, mimeTypeMap, 
    scroll, testerEmails, objDescSort, MyDate, isDevMode, getDatefromWeekNum,
    appTitle, 
} from "src/components/common/functions";
import FilterForm from "./filterForm";
import BalanceForm from "./balanceForm";
import Export from "./export";
import DayOffForm from "./dayOffsForm";import Detail from "./detail";
import WeekSelect from "../common/frame/weekSelect";

const title = "DayOffs";
//--------------------------------------------------------------------------------------------
export default function DayOffs({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    const editDayOff = () => {
        history.push(`/${title}/${id}/Edit`);
    }
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        if(!formData.get("approverEmail")){
            window.alert("The approver is not selected.");
            return;
        }
        if(!formData.get("requesterEmail")){
            window.alert("Please select requester.");
            return;
        }
        const action = formData.get("action") === "Add"?"create":"update";
        formData.delete("action");
        //-------------------------------------------
        // curData, fromDate, toDate, type, requesterEmail, approverEmail, notes
        // for "Update" Only: dayOffHashKey => excelId, formId, submitTime
        //-------------------------------------------
        setShowLoader(true);
        const res = await myAxios(`dayOffs/${action}DayOffs.php`, formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------
        const obj = res.data;
        if(action === "create"){
            setWeekEnd(weeknum(new Date()));
        }else{
            setDayOffs(dayOffs => dayOffs.map(dayOff => dayOff.dayOffHashKey === obj.dayOffHashKey?{
                ...obj,
                requester: usersListMap[obj.requesterEmail]?.userName ?? "", 
                submitter: usersListMap[obj.submitterEmail]?.userName ?? "", 
                updater: usersListMap[obj.updaterEmail]?.userName ?? "", 
                approver: usersListMap[obj.approverEmail]?.userName ?? "", 
            }:dayOff));
        }
        history.push(`/${title}`);
    }
    const statusColorCode = status => {
        switch(status){
            case "Submitted":
                return "black";
            case "Re-Submitted":
                return "purple";
            case "Approved":
                return "green";
            case "Rejected":
                return "gray";
            default:
        }
    }
    //--------------------------------------------------------------------------------------------
    const defaultFilter = {
        void: "", 
        createdByMe: false, 
        updatedByMe: false, 
        requesterEmail: "", 
        requestDate: "", 
        requestDate2: "", 
        totalMin: "", 
        totalMax: "", 
        type: "", 
        approverEmail: "", 
        status: "", 
        department: ""
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    const [showBalance, setShowBalanceForm] = useState(false);
    const [curWeekStart, setWeekStart] = useState(weeknum(new Date()));
    const [curWeekEnd, setWeekEnd] = useState(weeknum(new Date()));
    const [dayOffs, setDayOffs] = useState([]);
    const [showLoading, setShowLoading] = useState(true);
    const [usersList, setUsersList] = useState([]);
    const usersListMap = Object.fromEntries(usersList.map(user => [user.email, user]));
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    //--------------------------------------------------------------------------------------------
    const id = location.pathname.split("/")[2];
    const idid = location.pathname.split("/")[3];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterDayOffs = dayOffs?.map(u => ({...u, 
        requestDates: u.fromDate === u.toDate?u.fromDate:u.fromDate + " ~ " + u.toDate, 
        totalHours: JSON.parse(u.data).map(v => window.Number.parseFloat(v.hours || 0)).reduce(numberReducer, 0), 
        dateUpdated: u.dateUpdated ?? ""
    })).filter(u => 
        (user.projects === "no"?user.email === u.requesterEmail:true)
        && (curWeekStart?(weeknum(u.submitTime.substring(0, 10)) >= curWeekStart):true)
        && (curWeekEnd?(weeknum(u.submitTime.substring(0, 10)) <= curWeekEnd):true)
        && (curFilter.void === "All"?true:(u.void === curFilter.void))
        && (curFilter.createdByMe?u.submitterEmail === user.email:true)
        && (curFilter.updatedByMe?u.updaterEmail === user.email:true)
        && (curFilter.requesterEmail?u.requesterEmail === curFilter.requesterEmail:true)
        && (curFilter.department?u.department === curFilter.department:true)
        && (curFilter.requestDate?JSON.parse(u.data).map(u => u.date).includes(curFilter.requestDate):true)
        && (curFilter.requestDate2?JSON.parse(u.data).map(u => u.date).includes(curFilter.requestDate2):true)
        && (curFilter.totalMin?window.Number.parseFloat(u.totalHours) >= window.Number.parseFloat(curFilter.totalMin):true)
        && (curFilter.totalMax?window.Number.parseFloat(u.totalHours) <= window.Number.parseFloat(curFilter.totalMax):true)
        && (curFilter.type?u.type === curFilter.type:true)
        && (curFilter.approverEmail?u.approverEmail === curFilter.approverEmail:true)
        && (curFilter.status?u.status === curFilter.status:true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    ).sort((a, b) => objDescSort(a, b, "submitTime"));
    const currentDayOffs = filterDayOffs.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterDayOffs.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect 1");
        let isMounted = true;
        const getData = async() => {
            setShowLoading(true);
            const resUser = await myAxios("dayOffs/readUserNames.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resUser) return;
            setUsersList(resUser.data.map(user => ({...user, label: user.userName, value: user.email})));
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    },[updateDateTime])
    useEffect(() => {
        if(!usersList.length) return;
        if(isDevMode) console.log("useEffect 2");
        let isMounted = true;
        const id = history.location.pathname.split("/")[2];
        const getData = async() => {
            const formData = new MyFormData();
            formData.append("access", user.dayOff);
            formData.append("start", getDatefromWeekNum(curWeekStart, 0));
            formData.append("end", getDatefromWeekNum(curWeekEnd, 6));
            setShowLoading(true);
            const res = await myAxios("dayOffs/readDayOffs.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------------
            setDayOffs(res.data.map(dayOff => ({...dayOff, 
                requester: usersListMap[dayOff.requesterEmail]?.userName ?? "", 
                submitter: usersListMap[dayOff.submitterEmail]?.userName ?? "", 
                updater: usersListMap[dayOff.updaterEmail]?.userName ?? "", 
                approver: usersListMap[dayOff.approverEmail]?.userName ?? "", 
            })));
            if(!res.data.find(u => id === u.dayOffHashKey)){
                switch(id){
                    case "Add":
                        return;
                    case undefined:
                        return
                    default:
                }
                history.replace(`/${title}`);
                return;
            }
            const po = res.data.find(u => id === u.dayOffHashKey);
            if(po.void){setFilter(f => ({...f, void: "yes"}));}
            setWeekStart(weeknum(po.submitTime.substring(0, 10)));
            setWeekEnd(weeknum(po.submitTime.substring(0, 10)));
            const hashkeys = res.data
            .filter(u => u.void === po.void)
            .filter(u => weeknum(u.submitTime.substring(0, 10)) === weeknum(po.submitTime.substring(0, 10)))
            .map(v => v.dayOffHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(id) + 1) / itemsPerPage));
            scroll(id);
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    },[history, usersList, curWeekStart, curWeekEnd])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Time Offs
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <WeekSelect
                    curWeekStart = {curWeekStart}
                    setWeekStart = {setWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setWeekEnd = {setWeekEnd}
                    setCurrentPage = {setCurrentPage}
                    history = {history}
                    path1 = {title}
                    beginWeek = "2022/1/24"
                />
                {testerEmails.includes(user.email)?<>
                <span className = "pointer" onClick = {() => {setShowBalanceForm(true)}}>
                    Balance
                </span>
                {showBalance?
                <BalanceForm
                    closeIt = {() => setShowBalanceForm(false)}
                    filterDayOffs = {filterDayOffs}
                />:<></>}
                </>:<></>}
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).find(([key, value]) => defaultFilter[key] !== value)?
                    "rgb(0,123,255)"
                    :undefined
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm
                    usersList = {usersList}
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                />:<></>}
                <Export
                    filterDayOffs = {filterDayOffs}
                />
                <span className = "pointer" onClick = {() => {history.push(`/${title}/Add`);}}>Add</span>
                {id === "Add" && !showLoading?
                <DayOffForm  
                    handleSubmit = {handleSubmit} 
                    usersList = {usersList}
                    closeIt = {() => history.push(`/${title}`)} 
                    keyword = "Add" 
                    action = "create"
                />:<></>}
            </div>
            <div className="cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterDayOffs.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Department</th>
                                <th>Request Dates</th>
                                <th>Type</th>
                                <th>Submitted On</th>
                                <th>Approver</th>
                                <th>Status</th>
                                <th></th>
                                {user.dayOff === "all"?
                                <th></th>
                                :<></>}
                            </tr>
                        </thead>
                        <tbody>
                            {currentDayOffs.map((dayOff, key) => 
                            <Fragment key = {key}>
                            <tr id = {dayOff.dayOffHashKey}
                            style = {{
                                color: statusColorCode(dayOff.status),
                                background: dayOff.void === "yes"?"gray":"",
                                cursor:[dayOff.requesterEmail, dayOff.approverEmail, dayOff.submitterEmail, dayOff.updaterEmail].includes(user.email)?"pointer":""
                            }} onClick = {e => {
                                if(!e.target.id){
                                    if([dayOff.requesterEmail, dayOff.approverEmail, dayOff.submitterEmail, dayOff.updaterEmail].includes(user.email) && id !== e.currentTarget.id){
                                        history.push(`/${title}/${e.currentTarget.id}`);
                                        scroll(e.currentTarget.id);
                                    }else{
                                        history.push(`/${title}`);
                                        scroll(null);
                                    }
                                }
                            }}>
                                <td className = {
                                    ![dayOff.requesterEmail, dayOff.approverEmail, dayOff.submitterEmail, dayOff.updaterEmail].includes(user.email)?"":id === dayOff.dayOffHashKey?"showMinus":"showPlus"}></td>
                                <td id = {dayOff.requesterEmail}>
                                    <UserInfo 
                                        name = {dayOff.requester}
                                        email = {dayOff.requesterEmail}
                                    />
                                </td>
                                <td>{dayOff.department}</td>
                                <td>
                                    <div>{dayOff.requestDates}</div>
                                    <ul>
                                        {JSON.parse(dayOff.data).map((v, i) => <li key = {i}>
                                            <span className = "mx-2">{v.date}</span>
                                            {v.holiday || v.weekend?<></>:<>{v.startTime} {v.hours}<span className = "mx-2">hours</span></>}
                                            {v.holiday?<span className = "mx-2 text-info">({v.holidayName})</span>:<></>}
                                            {v.weekend?<span className = "mx-2 text-success">(weekend)</span>:<></>}
                                        </li>)}
                                    </ul>
                                    {JSON.parse(dayOff.data).length?
                                    <div className = "font-weight-bold">
                                        Total: <span className = "text-success">{dayOff.totalHours} hours</span>
                                    </div>
                                    :<></>}
                                </td>
                                <td>{dayOff.type}</td>
                                <td>{dayOff.submitTime}</td>
                                <td>
                                    <UserInfo 
                                        name = {dayOff.approver}
                                        email = {dayOff.approverEmail}
                                    />
                                </td>
                                <td>{dayOff.status}</td>
                                <td>
                                    {[dayOff.requesterEmail, dayOff.approverEmail, dayOff.submitterEmail, dayOff.updaterEmail].includes(user.email) || user.dayOff === "all"?
                                    <span id = {dayOff.formId} className = "btn btn-success" onClick = {async() => {
                                        if(!dayOff.formId){
                                            window.alert("PDF Error.");
                                            return
                                        };
                                        const formData = new MyFormData();
                                        formData.append("fileId[]", dayOff.formId);
                                        //-------------------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("common/getFile.php", formData, "blob");
                                        setShowLoader(false);
                                        if(!res) return;
                                        //-------------------------------------------------------------------
                                        const file = new Blob([res.data], {type: mimeTypeMap.pdf});
                                        saveAs(file, `Absence Request - ${dayOff.requester} ${dayOff.requestDates}.pdf`);
                                    }}>Form</span>
                                    :<></>}
                                </td>
                                {user.dayOff === "all"?
                                <td>
                                    <span className = {!dayOff.paid?"btn btn-primary":"btn btn-info"}
                                    onClick = {async() => {
                                        const formData = new MyFormData();
                                        formData.append("dayOffHashKey", dayOff.dayOffHashKey);
                                        formData.append("paid", !dayOff.paid?"yes":"");
                                        //-------------------------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("dayOffs/paid.php", formData)
                                        setShowLoader(false);
                                        if(!res) return;
                                        //-------------------------------------------------------------------
                                        setDayOffs(dayOffs => dayOffs.map(dO => dO.dayOffHashKey === dayOff.dayOffHashKey?{
                                            ...dO, 
                                            "paid": !dayOff.paid?"yes":""
                                        }:dO));
                                        history.replace(`/${title}`);
                                        scroll(null);
                                    }}
                                    >{!dayOff.paid?<>Mark</>:<>Unmark</>}</span>
                                </td>
                                :<></>}
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                    <Detail
                                        setDayOffs = {setDayOffs}
                                        id = {id}
                                        idid = {idid}
                                        dayOff = {dayOff}
                                        history = {history}
                                        editDayOff = {editDayOff}
                                        handleSubmit = {handleSubmit}
                                        usersList = {usersList}
                                    />
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterDayOffs.length?
                <Footer
                    length = {filterDayOffs.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}
